import React from "react";

const ProgressSteps = ({ currentStep, onStepClick }) => {
  const steps = [
    { number: 1, label: "Seleção" },
    { number: 2, label: "Processamento" },
    { number: 3, label: "Revisão" },
    { number: 4, label: "Conclusão" },
  ];

  return (
    <div className="w-full max-w-4xl mb-6">
      <div className="flex items-center justify-center mb-2">
        <h1 className="text-2xl font-semibold text-gray-800">
          Importação de Beneficiários
        </h1>
      </div>
      <div className="relative pt-1">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div
                className={`flex flex-col items-center cursor-pointer ${
                  currentStep >= step.number
                    ? "text-emerald-700"
                    : "text-gray-400"
                }`}
                onClick={() => step.number === 1 && onStepClick()}
                title={step.number === 1 ? "Voltar ao início" : ""}
              >
                <div
                  className={`rounded-full h-8 w-8 flex items-center justify-center border-2 ${
                    currentStep >= step.number
                      ? "border-emerald-700 bg-emerald-50"
                      : "border-gray-300"
                  }`}
                >
                  {step.number}
                </div>
                <span className="text-xs mt-1">{step.label}</span>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-1 mx-2 ${
                    currentStep >= step.number + 1
                      ? "bg-emerald-500"
                      : "bg-gray-300"
                  }`}
                ></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressSteps;
